'use strict';

require('formdata-polyfill');

require('unfetch/polyfill');

require('es6-promise/auto');

require('./modernizr');